<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование офиса" : "Добавление офиса"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs8)
          v-text-field(
            :error='errors.has("office_name")'
            :error-messages='errors.first("office_name")'
            v-model='item.office_name'
            label='Название'
          )
        v-flex(xs4)
          v-checkbox(
            v-model='item.published'
            label='Публиковать на сайте'
            color='primary'
          )
        v-flex(xs12)
          s-address-suggest(
            :error='errors.has("address_full")'
            :error-messages='errors.first("address_full")'
            @change='onAddressSuggestChange'
            v-model='item.address_full'
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("address_geo_lat")'
            :error-messages='errors.first("address_geo_lat")'
            v-model='item.address_geo_lat'
            label='Широта'
          )
        v-flex(xs5)
          v-text-field(
            :error='errors.has("address_geo_lon")'
            :error-messages='errors.first("address_geo_lon")'
            v-model='item.address_geo_lon'
            label='Долгота'
          )
        v-flex(xs1)
          v-btn(icon @click.stop='onCoordinatesDelete')
            v-icon(small) delete_outline
        v-flex(xs12 sm6 md4)
          s-region-picker(
            :error='errors.has("region_code")'
            :errors-messages='errors.first("region_code")'
            v-model='item.region_id'
          )
        v-flex(xs12 sm6 md4)
          v-text-field(
            :error='errors.has("address_city")'
            :error-messages='errors.first("address_city")'
            v-model='item.address_city'
            label='Город'
          )
        v-flex(xs12 sm6 md4)
          s-phone-input(
            :error='errors.has("phone")'
            :error-messages='errors.first("phone")'
            v-model='item.phone'
            label='Телефон'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("about")'
            :error-messages='errors.first("about")'
            v-model='item.work_time'
            label='Режим работы'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("meta_h1")'
            :error-messages='errors.first("meta_h1")'
            v-model='item.meta_h1'
            label='Заголовок H1 для детальной страницы офиса'
          )
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.avatar_url'
            v-model='item.avatar'
            label='Фотография офиса'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
  list(
    v-if='id'
    :office-id='id'
    class='mt-5'
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import List from './departments/List'

export default {
  props: ['id'],

  data: () => ({
    focused: false,
    item: {
      dadata: {}
    },
    changeCoords: false
  }),

  components: {
    List
  },

  async created() {
    if (this.id) {
      try {
        this.item = (await this.fetchSingle({ id: this.id })).data
        this.item.dadata = {}
        if (!this.item.address_geo_lat && !this.item.address_geo_lon) {
          this.changeCoords = true
        }
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки офиса')
      }
    } else {
      this.changeCoords = true
    }
  },

  methods: {
    onCoordinatesDelete() {
      this.changeCoords = true
      this.item.address_geo_lat = null
      this.item.address_geo_lon = null
      this.item = Object.assign({}, this.item)
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.item
          })
        } else {
          await this.create({
            data: this.item
          })
        }

        this.$root.showSnack(`Офис сохранен`)
        this.$router.push({ name: 'Admin.Offices' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    onAddressSuggestChange({ data, value, unrestricted_value }) {
      if (null !== data.city) {
        this.item.address_city = data.city
      }

      let coords = {}
      if (this.changeCoords) {
        coords.address_geo_lat = data.geo_lat
        coords.address_geo_lon = data.geo_lon
      }

      Object.assign(this.item, {
        dadata: {
          ...data,
          value,
          unrestricted_value
        },
        address_fias_id: data.fias_id
      }, coords)
    },

    ...mapActions('admin/offices', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('admin/offices', ['isLoading'])
  }
}
</script>
